<template>
  <div class="userService">
    <div class="header">用户纠纷制度</div>
    <div class="con">
        太原巴卡巴科技在此特别提醒用户在注册、登陆本公司前请务必仔细阅读本《纠纷处理方式》 （未成年人应当在其法定监护人陪同下阅读）中的各个条款，以确保您在享受本公司服务的同时维护自身合法权益：<br/>
        一、用户之间纠纷处理方式<br/>
        1．太原巴卡巴科技仅作为本公司的运营商，如若本公司用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决，包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。太原巴卡巴科技将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。<br/>
        2．本公司用户之间发生纠纷的，也可向太原巴卡巴科技的客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他太原巴卡巴科技要求提供的相关证据。经太原巴卡巴科技审核确认后，可以给予必要的协助和支持。<br/>
        二、用户与太原巴卡巴科技之间纠纷处理方式<br/>
        1．如本公司用户对太原巴卡巴科技的服务有任何异议的，可以向太原巴卡巴科技 的客服人员投诉并举证。查证属实的，太原巴卡巴科技将立即更正并按照现行法律规定给予用户必要的补偿。<br/>
        2．如本公司用户对太原巴卡巴科技的服务有任何异议的，也可以向双方约定（具体参见《太原巴卡巴科技公司使用协议》）的太原巴卡巴科技所在地人民法院提起诉讼。 根据《公司管理暂行规定》（文化部令第49号），文化部制定《公司服务格式化协议必备条款》。甲方为公司运营企业，乙方为公司用户。<br/>
        三. 账号注册<br/>
        1.1 乙方承诺以其真实身份注册成为甲方的用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和必备条款约定对所提供的信息承担相应的法律责任。 1.2 乙方以其真实身份注册成为甲方用户后，需要修改所提供的个人身份资料信息的，甲方应当及时、有效地为其提供该项服务。<br/>
       2.用户账号使用与保管 <br/>
        2.1 根据必备条款的约定，甲方有权审查乙方注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合理措施保障用户账号的安全、有效；乙方有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给乙方和他人的民事权利造成损害的，应当承担由此产生的法律责任。
2.2乙方对登录后所持账号产生的行为依法享有权利和承担责任。<br/>
        2.3 乙方发现其账号或密码被他人非法使用或有使用异常的情况的，应及时根据甲方公布的处理方式通知甲方，并有权通知甲方采取措施暂停该账号的登录和使用。<br/>
        2.4 甲方根据乙方的通知采取措施暂停乙方账号的登录和使用的，甲方应当要求乙方提供并核实与其注册身份信息相一致的个人有效身份信息。<br/>
        2.4.1 甲方核实乙方所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停乙方账号的登录和使用。<br/>
       2.4.2 甲方违反2.4.1款项的约定，未及时采取措施暂停乙方账号的登录和使用，因此而给乙方造成损失的，应当承担其相应的法律责任。 <br/>
        2.4.3 乙方没有提供其个人有效身份证件或者乙方提供的个人有效身份证件与所注册的身份信息不一致的，甲方有权拒绝乙方上述请求。<br/>
        2.5 乙方为了维护其合法权益，向甲方提供与所注册的身份信息相一致的个人有效身份信息时，甲方应当为乙方提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。<br/>
        3.服务的中止与终止 3.1乙方有发布违法信息、严重违背社会公德、以及其他违反法律禁止性规定的行为，甲方应当立即终止对乙方提供服务。<br/>
        3.2乙方在接受甲方服务时实施不正当行为的，甲方有权终止对乙方提供服务。该不正当行为的具体情形应当在本协议中有明确约定或属于甲方事先明确告知的应被终止服务的禁止性行为，否则，甲方不得终止对乙方提供服务。<br/>
        3.3乙方提供虚假注册身份信息，或实施违反本协议的行为，甲方有权中止对乙方提供全部或部分服务；甲方采取中止措施应当通知乙方并告知中止期间，中止期间应该是合理的，中止期间届满甲方应当及时恢复对乙方的服务。<br/>
        3.4 甲方根据本条约定中止或终止对乙方提供部分或全部服务的，甲方应负举证责任。<br/>
        4.用户信息保护<br/>
        4.1 甲方要求乙方提供与其个人身份有关的信息资料时，应当事先以明确而易见的方式向乙方公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护乙方的个人信息资料的安全。<br/>
        4.2未经乙方许可甲方不得向任何第三方提供、公开或共享乙方注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：<br/>
        4.2.1 乙方或乙方监护人授权甲方披露的；<br/>
        4.2.2 有关法律要求甲方披露的；<br/>
        4.2.3 司法机关或行政机关基于法定程序要求甲方提供的；<br/>
       4.2.4 甲方为了维护自己合法权益而向乙方提起诉讼或者仲裁时； <br/>
        .2.5 应乙方监护人的合法要求而提供乙方个人身份信息时。<br/>
        
      </div>

  </div>
</template>

<script setup>
import { ref, watch } from "vue";
let serviceList = ref([
  { title: '一、【协议的范围】', id: 1 }, { title: '二、【创作发表作品】', id: 2 }, { title: '三、【发布作品审核】', id: 3 }, { title: '四、【收益】', id: 4 }, { title: '五、【其他】', id: 5 }
])

</script>

<style lang="scss" scoped>
.userService {
  .header {
    font-size: 28px;
    
    color: #333333;
    line-height: 40px;
  }

  .con {
    font-size: 18px;
    font-weight: 400;font-weight: lighter;
    color: #333333;
    line-height: 36px;
    margin-top: 30px;
  }

  .serviceWrap {
    &_title {
      // background-color: rgb(255, 127, 170);
      font-size: 22px;
      
      color: #333333;
      line-height: 30px;
      margin: 30px 0 20px;
    }

    &_con {
      font-size: 18px;
      font-weight: 400;font-weight: lighter;
      color: #333333;
      line-height: 36px;
    }

    &_con1 {
      font-size: 16px;
    }
  }

}
</style>